/**
 * A same-tab signal that a firm setting was saved, so views that read the
 * firm record (the case IDE's workflows) refetch it without a reload.
 */
export const FIRM_UPDATED_EVENT = "caseblink:law-firm-updated";

export const announceFirmUpdated = (lawFirmId: string): void => {
  window.dispatchEvent(
    new CustomEvent(FIRM_UPDATED_EVENT, { detail: { lawFirmId } })
  );
};
